import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  styled,
} from '@mui/material';

export const RequirementItemStyled = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0),
  marginTop: '0.5rem !important',
}));

export const RequirementItemIconStyled = styled(ListItemIcon)({
  minWidth: 0,
  alignItems: 'center',
});

export const RequirementsTitleStyled = styled('h2')({
  wordWrap: 'break-word',
  textTransform: 'none',
}) as typeof Typography;

export const RequirementItemTextStyled = styled(ListItemText)({
  margin: 0,
});
